    // Define an action to set the price
export const setPrice = (priceAt) => {
    return {
      type: "SET_PRICE",
      payload: priceAt,
    };
  };
  